
/**
 * MapLibreのexpression配列（case式など）に条件と値をデフォルト値の直前に挿入する
 * @param expression - case式などの配列
 * @param condition - 挿入する条件式
 * @param value - 挿入する値
 * @returns 挿入後の新しい配列
 */
export function insertConditionToExpression(expression: unknown, condition: unknown, value: unknown): unknown {
    if (!Array.isArray(expression)) { return expression; }
    // case式の場合
    if (expression[0] === 'case') {
        const newExpr = [...expression];
        newExpr.splice(1, 0, condition, value);
        return newExpr;
    }

    return expression;
}

/**
 * 指定したcondition配列が、MapLibreのexpression配列（case式など）内に含まれているかどうかを判定する
 * @param expression - 検索対象のexpression配列
 * @param condition - 探したい条件配列
 * @param partial - trueの場合は部分一致（conditionがitemの先頭から一致すればOK）、falseなら完全一致
 */
export const includesExpressionCondition = (
    expression: unknown,
    condition: unknown[],
    partial: boolean = false
): boolean => {
    if (!Array.isArray(expression)) { return false; }
    if (partial) {
        return expression.some(item =>
            Array.isArray(item) &&
            condition.every((v, i) => JSON.stringify(item[i]) === JSON.stringify(v))
        );
    } else {
        const conditionStr = JSON.stringify(condition);
        return expression.some(item => JSON.stringify(item) === conditionStr);
    }
};

/**
 * 指定したcondition配列が、MapLibreのexpression配列（case式など）内のどのindexにあるかを返す
 * @param expression - 検索対象のexpression配列
 * @param condition - 探したい条件配列
 * @param partial - trueの場合は部分一致（conditionがitemの先頭から一致すればOK）、falseなら完全一致
 * @returns index（見つからなければ-1）
 */
export const findExpressionConditionIndex = (
    expression: unknown,
    condition: unknown[],
    partial: boolean = false
): number => {
    if (!Array.isArray(expression)) { return -1; }
    if (partial) {
        return expression.findIndex(item =>
            Array.isArray(item) &&
            condition.every((v, i) => JSON.stringify(item[i]) === JSON.stringify(v))
        );
    } else {
        const conditionStr = JSON.stringify(condition);
        return expression.findIndex(item => JSON.stringify(item) === conditionStr);
    }
};
